/**
 * ハンバーガーメニュー
 */

import $ from 'jquery'

// js-humberger toggle
const $humberger = $('.js-humberger');

// js-humberger close
const $humbergerClose = $('a[href^="#"]');

// メニューオープン時に付与するクラス
const isOpenedMenu = 'is-opened-humberger';

// メニューオープン時にクラスを付与するセレクタ
const target = '.js-humberger-target';

// メニュー開閉
$humberger.click(function(){
  if ($(this).hasClass(isOpenedMenu)) {
    $(this).removeClass(isOpenedMenu);
    $(target).removeClass(isOpenedMenu);
  } else {
    $(this).addClass(isOpenedMenu);
    $(target).addClass(isOpenedMenu);
  }
});

// メニュー閉じる
$humbergerClose.click(function(){
  $humberger.removeClass(isOpenedMenu);
  $(target).removeClass(isOpenedMenu);
});